import { render, staticRenderFns } from "./RejectedTask.vue?vue&type=template&id=62d8eb4c&scoped=true"
import script from "./RejectedTask.vue?vue&type=script&lang=js"
export * from "./RejectedTask.vue?vue&type=script&lang=js"
import style0 from "./RejectedTask.vue?vue&type=style&index=0&id=62d8eb4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8eb4c",
  null
  
)

export default component.exports